import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import First from "./Landingpage/First";
import Privacy from "./Landingpage/privacy_policy";
import Termscondition from "./Landingpage/Terms&condition";
import Faq from "./Landingpage/Faq";
import Pricing from "./Landingpage/Pricing";
// import Contactus from "./Landingpage/Contact";
import ContactForm from "./Landingpage/Invite";
import ChatWidget from "./Landingpage/ChatBot";
import Competitiveresearch from "./Landingpage/Competitiveresearch";
import Domainoverview from "./Landingpage/Domainoverview";
import Keywordgap from "./Landingpage/Keywordgap";
import Onpageseo from "./Landingpage/Onpageseo";
import Seoaudit from "./Landingpage/Seoauditpage";
import Page from "./Landingpage/Page";
import Structure from "./Landingpage/Structure";
import Internallink from "./Landingpage/Internallink";
import Sitemappage from "./Landingpage/Sitemappage";
import Sociallinks from "./Landingpage/Sociallink";
import Robot from "./Landingpage/Robot";
import Domainage from "./Landingpage/Domainage";
import Linkbuilding from "./Landingpage/Linkbuilding";
import Serp from "./Landingpage/Serp";
import Keywordresearch from "./Landingpage/Keywrodresearch";
import Linkingdomain from "./Landingpage/Linkingdomain";
import Googletrend from "./Landingpage/Googletrend";
import Trendingnow from "./Landingpage/Trendingnow";
import Trendingovertime from "./Landingpage/Interestovertime";
import Toppages from "./Landingpage/Toppages";
import Risingtopic from "./Landingpage/Risingtopic";
import Urlinspect from "./Landingpage/Url";
import Keywordbuilder from "./Landingpage/Keybuilder";
import Magictool from "./Landingpage/Magictool";
import Connectus from "./Landingpage/Connect";
import Inspectnow from "./Landingpage/Inspect";
import Contentgenerator from "./Landingpage/Contentgenerator";
import Contentquality from "./Landingpage/Qualitycontent";
import Humanizer from "./Landingpage/Humanizer";
import Backlinkchecker from "./Landingpage/Backlinkchecker";
import Googleanalytics from "./Landingpage/Googleanalytics";
import Googleconsole from "./Landingpage/Gsearchconsole";
// import trialGif from "../src/Images/newgif.gif";
import { Col, Row } from "react-bootstrap";
import Ranksitekeyword from "./Landingpage/Rankkeyword";
import Guestpost from "./Landingpage/Guestpost";
import Positiontracker from "./Landingpage/Positiontracker";
import Partners from "./Landingpage/Partner";
import Newregister from "./Landingpage/Newregister";
import Blog from "./Landingpage/Blog";
import Article from "./Landingpage/Article";
import Author from "./Landingpage/Author";
import GoogleOneTapLogin from "./Landingpage/GoogleOneTap";
import YouTubeTrendingTagsFinder from "./Landingpage/YouTubeTrendingTagsFinder";
import YouTubeBixIntelligence from "./Landingpage/YouTubeBixIntelligence";
import YouTubeScheduledPublishing from "./Landingpage/YouTubeScheduledPublishing";
import YouTubeContentPlanner from "./Landingpage/YouTubeContentPlanner";
import YouTubeSubscriptionTracker from "./Landingpage/YouTubeSubscriptionTracker";
import YouTubeInsightAnalyzer from "./Landingpage/YouTubeInsightAnalyzer";
import FacebookProfilePageAnalyzer from "./Landingpage/FacebookProfilePageAnalyzer";
import FacebookPostContentCreator from "./Landingpage/FacebookPostContentCreator";
import FacebookPostScheduler from "./Landingpage/FacebookPostScheduler";
import FacebookHashtagFinder from "./Landingpage/FacebookHashtagFinder";
import LinkedInProfileAnalyzer from "./Landingpage/LinkedInProfileAnalyzer";
import LinkedInHashtagResearchTool from "./Landingpage/LinkedInHashtagResearchTool";
import LinkedInPostScheduler from "./Landingpage/LinkedInPostScheduler";
import LinkedInPostArticleCreator from "./Landingpage/LinkedInPostArticleCreator";
import InstagramHashtagGenerator from "./Landingpage/InstagramHashtagGenerator";
import InstagramTagAnalyzer from "./Landingpage/InstagramTagAnalyzer";
import InstagramPostScheduler from "./Landingpage/InstagramPostScheduler";
import InstagramPostReelCreator from "./Landingpage/InstagramPostReelCreator";
import InstagramProfileAnalyzer from "./Landingpage/InstagramProfileAnalyzer";
// const BottomBanner = () => {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         bottom: 0,
//         width: "100%",
//         background: "#8F87F1",
//         color: "#fff",
//         textAlign: "center",
//         padding: "10px 16px",
//         fontSize: "18px",
//         fontWeight: "600",
//         zIndex: 999,
//         boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         gap: "12px",
//         flexWrap: "wrap",
//       }}
//     >
//       <div className="bounce-icon" style={{ fontSize: "2rem" }}>
//         🎁
//       </div>

//       <div className="shimmer-text">
//         Get 3 Months of SeoBix Premium — Absolutely Free! Unlock Site Audits,
//         Keyword Insights, Backlink Tracking, Social Media Handling & more!
//       </div>

//       <a href="/register" className="start-now-btn">
//         Start Now
//       </a>

//       <style>
//         {`
//         .bounce-icon {
//           animation: bounce 1s infinite;
//         }

//         @keyframes bounce {
//           0%, 100% {
//             transform: translateY(0);
//           }
//           50% {
//             transform: translateY(-8px);
//           }
//         }

//         .shimmer-text {
//           background: linear-gradient(90deg, #ffffff, #e4e4e4, #ffffff);
//           background-size: 200% auto;
//           color: #fff;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           animation: shimmer 2s linear infinite;
//           font-weight: 700;
//         }

//         @keyframes shimmer {
//           0% {
//             background-position: -100% 0;
//           }
//           100% {
//             background-position: 100% 0;
//           }
//         }

//         .start-now-btn {
//           background-color: #fff;
//           color: #8F87F1;
//           padding: 8px 16px;
//           border-radius: 999px;
//           text-decoration: none;
//           font-weight: bold;
//           transition: all 0.3s ease;
//           animation: pulse 2s infinite;
//           box-shadow: 0 0 0 rgba(255, 255, 255, 0.7);
//         }

//         @keyframes pulse {
//           0% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
//           }
//           70% {
//             transform: scale(1.08);
//             box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
//           }
//           100% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
//           }
//         }

//         .start-now-btn:hover {
//           background-color: #e4e4e7 !important;
//         }
//         `}
//       </style>
//     </div>
//   );
// };
// const BottomBanner = () => {
//   const [showBanner, setShowBanner] = useState(true);

//   if (!showBanner) return null;

//   return (
//     <div
//       style={{
//         position: "fixed",
//         bottom: 0,
//         width: "100%",
//         background: "#8F87F1",
//         color: "#fff",
//         padding: "10px 12px",
//         fontSize: "16px",
//         fontWeight: "600",
//         zIndex: 999,
//         boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         gap: "12px",
//         flexWrap: "wrap",
//         textAlign: "center",
//       }}
//     >
//       {/* Gift Icon */}
//       {/* <div className="bounce-icon" style={{ fontSize: "1.6rem" }}>🎁</div> */}

//       {/* Message */}
//       <div className="shimmer-text banner-text" style={{ flex: "1 1 300px" }}>
//         Get 3 Months of SeoBix Premium — Absolutely Free! Unlock Site Audits,
//         Keyword Insights, Backlink Tracking, Social Media Handling & more!
//       </div>

//       {/* CTA Buttons */}
//       <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//         <a href="/register" className="start-now-btn">
//           Start Now
//         </a>
//         <button className="deny-btn" onClick={() => setShowBanner(false)}>
//           Deny
//         </button>
//       </div>

//       <style>
//         {`
//         .bounce-icon {
//           animation: bounce 1s infinite;
//         }

//         @keyframes bounce {
//           0%, 100% {
//             transform: translateY(0);
//           }
//           50% {
//             transform: translateY(-6px);
//           }
//         }

//         .shimmer-text {
//           background: linear-gradient(90deg, #ffffff, #e4e4e4, #ffffff);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           animation: shimmer 2s linear infinite;
//           font-weight: 700;
//         }

//         .start-now-btn,
//         .deny-btn {
//           padding: 8px 16px;
//           border-radius: 999px;
//           font-weight: bold;
//           text-decoration: none;
//           border: none;
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .start-now-btn {
//           background-color: #fff;
//           color: #8F87F1;
//           animation: pulse 2s infinite;
//         }

//         .start-now-btn:hover {
//           background-color: #e4e4e7 !important;
//         }

//         .deny-btn {
//           background-color: transparent;
//           color: #fff;
//           border: 2px solid #fff;
//         }

//         .deny-btn:hover {
//           background-color: rgba(255,255,255,0.1);
//         }

//         @keyframes pulse {
//           0% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
//           }
//           70% {
//             transform: scale(1.08);
//             box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
//           }
//           100% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
//           }
//         }
//         `}
//       </style>
//     </div>
//   );
// };

function App() {
  const [showModal, setShowModal] = useState(false);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowModal(true);
  //   }, 100);
  //   return () => clearTimeout(timer);
  // }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <Router>
      <div>
        <GoogleOneTapLogin />

        <Routes>
          <Route path="/" element={<First />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-and-Conditions" element={<Termscondition />} />
          <Route path="/pricing-plans" element={<Pricing />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/blog/:post_slug" element={<Article />} />
          <Route path="/contact-us" element={<Connectus />} />
          <Route path="/invite-us" element={<ContactForm />} />
          <Route path="/ChatWidget" element={<ChatWidget />} />
          <Route path="/Sitereport" element={<Inspectnow />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/guest-post" element={<Guestpost />} />
          <Route path="/register" element={<Newregister />} />
          <Route path="/best-keyword-research-tool" element={<Magictool />} />
          <Route path="/bix-keyword-analyzer" element={<Ranksitekeyword />} />
          <Route
            path="/construct-your-seo-success-with-keyword-builder"
            element={<Keywordbuilder />}
          />
          <Route path="/author/:post_slug" element={<Author />} />
          <Route path="/best-url-inspection-tool" element={<Urlinspect />} />
          <Route path="/top-pages" element={<Toppages />} />
          <Route
            path="/boost-google-ranking-with-keyword-interest"
            element={<Trendingovertime />}
          />
          <Route path="/trending-now-on-google" element={<Trendingnow />} />
          <Route path="/linking-domain-checker" element={<Linkingdomain />} />
          <Route
            path="/increase-google-ranking-with-trending-topics"
            element={<Risingtopic />}
          />
          <Route path="/free-google-trends-tool" element={<Googletrend />} />
          <Route
            path="/best-keyword-research-tool-in-india-2025"
            element={<Keywordresearch />}
          />
          <Route path="/serp-simulator" element={<Serp />} />
          <Route path="/manage-robots-txt" element={<Robot />} />
          <Route
            path="/keyword-position-tracker"
            element={<Positiontracker />}
          />
          <Route path="/structured-data" element={<Structure />} />
          <Route
            path="/boost-your-seo-with-smart-internal-linking-strategies"
            element={<Internallink />}
          />
          <Route
            path="/generate-your-perfect-sitemap-in-seconds-with-our-seobix-tool"
            element={<Sitemappage />}
          />
          <Route
            path="/boost-your-social-media-with-the-best-social-links-generator"
            element={<Sociallinks />}
          />

          <Route path="/on-page-seo-tool" element={<Page />} />
          <Route path="/seo-Inspector" element={<Seoaudit />} />
          <Route
            path="/competitive-research-with-seobix-understand-your-competitors-strategies"
            element={<Competitiveresearch />}
          />
          <Route path="/da-pa-checker" element={<Domainoverview />} />
          <Route path="/keyword-gap" element={<Keywordgap />} />
          <Route
            path="/best-free-on-page-seo-tool-for-high-google-rankings"
            element={<Onpageseo />}
          />
          <Route path="/backlink-checker" element={<Backlinkchecker />} />
          <Route
            path="/domain-age-checker-track-website-journey"
            element={<Domainage />}
          />
          <Route path="/search-console" element={<Googleconsole />} />
          <Route path="/google-analytics" element={<Googleanalytics />} />
          <Route path="/link-building-tool" element={<Linkbuilding />} />
          <Route path="/bix-content-generator" element={<Contentgenerator />} />
          <Route path="/content-quality-checker" element={<Contentquality />} />
          <Route path="/bix-humanizer" element={<Humanizer />} />

          <Route
            path="/youtube-scheduled-publishing"
            element={<YouTubeScheduledPublishing />}
          />
          <Route
            path="/youtube-subscription-tracker"
            element={<YouTubeSubscriptionTracker />}
          />
          <Route
            path="/youtube-trending-tags-finder"
            element={<YouTubeTrendingTagsFinder />}
          />
          <Route
            path="/youtube-bix-intelligence"
            element={<YouTubeBixIntelligence />}
          />
          <Route
            path="/youtube-content-planner"
            element={<YouTubeContentPlanner />}
          />
          <Route
            path="/youtube-insight-analyzer"
            element={<YouTubeInsightAnalyzer />}
          />

          {/* --- Facebook Routes --- */}
          <Route
            path="/facebook-profile-page-analyzer"
            element={<FacebookProfilePageAnalyzer />}
          />
          <Route
            path="/facebook-post-content-creator"
            element={<FacebookPostContentCreator />}
          />
          <Route
            path="/facebook-post-scheduler"
            element={<FacebookPostScheduler />}
          />
          <Route
            path="/facebook-hashtag-finder"
            element={<FacebookHashtagFinder />}
          />

          {/* --- LinkedIn Routes --- */}
          <Route
            path="/linkedin-profile-analyzer"
            element={<LinkedInProfileAnalyzer />}
          />
          <Route
            path="/linkedin-post-article-creator"
            element={<LinkedInPostArticleCreator />}
          />
          <Route
            path="/linkedin-post-scheduler"
            element={<LinkedInPostScheduler />}
          />
          <Route
            path="/linkedin-hashtag-research-tool"
            element={<LinkedInHashtagResearchTool />}
          />

          {/* --- Instagram Routes --- */}
          <Route
            path="/instagram-profile-analyzer"
            element={<InstagramProfileAnalyzer />}
          />
          <Route
            path="/instagram-post-reel-creator"
            element={<InstagramPostReelCreator />}
          />
          <Route
            path="/instagram-post-scheduler"
            element={<InstagramPostScheduler />}
          />
          <Route
            path="/instagram-hashtag-generator"
            element={<InstagramHashtagGenerator />}
          />
          <Route
            path="/instagram-tag-analyzer"
            element={<InstagramTagAnalyzer />}
          />
        </Routes>
      </div>
      <ChatWidget />
      {/* <BottomBanner /> */}
    </Router>
  );
}

export default App;
